import { useEffect, useRef, useState } from 'react'
import { Table } from '../../components/Inputs/Table'
import { api } from '../../components/api/api'
import { Alert, AlertErro } from '../../util/Alertas'
import ModalDeposito from './modals/ModalDeposito'
import { TiPlus } from 'react-icons/ti'
import { Col, Row } from 'react-bootstrap'
import DepositoEstoque from './modals/ModalDepositoEstoque'

const Deposito = () => {
    const depositoRef = useRef();
    const estoqueRef = useRef();
    const [depositos, setDepositos] = useState([])
    const [nomeFilter, setNomeFilter] = useState('')

    const columns = [
        { accessor: "depositoId", header: 'Id' }, //render: actionsColumn
        { accessor: "depositoNome", header: 'Nome Do Deposito' }, //render: actionsColumn
    ]

    const getDepositos = () => {
        api.get("/api/Deposito", res => {
            setDepositos(res.data);
        }, err => {
            console.log(err);
            AlertErro(err);
        })
    }

    const onDelete = (id) => {
        api.delete("/api/Deposito/" + id, res => {
            Alert('Deposito deletado com sucesso!');
            setDepositos(res.data);
        }, err => {
            console.log(err);
            AlertErro(err);
        })
    }

    useEffect(() => {
        getDepositos()
    }, []);

    return (
        <section className='app'>
            <ModalDeposito
                ref={depositoRef}
                setDepositos={setDepositos}
            />
            <DepositoEstoque
                ref={estoqueRef}
            />
            <div className="content">
                <h2>Depositos:</h2>
                <small>Filtro:</small>
                <div style={{ marginBottom: 5, width: '100%', display: 'flex', gap: 2 }} className='d-flex'>
                    <input placeholder='Buscar por Nome' className='form-control' value={nomeFilter} onChange={e => setNomeFilter(e.target.value)} type="text" name="" id="" />
                    <button onClick={e => depositoRef.current.openModal(false, 0, '')} className='btn btn-primary'>Adicionar Novo Deposito <TiPlus size={23} color='#fff' /></button>
                </div>
                <Table
                    enableActions
                    columns={columns}
                    data={depositos.filter(x => x.depositoNome.toLocaleLowerCase().includes(nomeFilter.toLocaleLowerCase()))}
                    keyField="depositoId"
                    onEdit={row => depositoRef.current.openModal(true, row.depositoId, row.depositoNome)}
                    onDelete={row => onDelete(row.depositoId)}
                    onView={row => estoqueRef.current.openModal(row.depositoId)}
                />
            </div>
        </section>
    )
}

export default Deposito